export default "__VITE_ASSET__DftR3tSJ__"